export function calculateSubnavHeight(subnav, offset) {
    if(subnav) {
        let headerHeight = document.querySelector('.headerMain').getBoundingClientRect().height;
        let windowHeight = window.innerHeight;
        let subNavCalculatetHeight = windowHeight - headerHeight - offset;
        subnav.style.maxHeight = subNavCalculatetHeight + 'px';
    }
}